import dayjs from 'dayjs'

export function formatDate(date: Date, formatStr: string) {
  return dayjs(date).format(formatStr)
}
// 获得当前时间默认时间点
export function getDefaultDateTime() {
  const formatStr = 'YYYY-MM-DD HH:mm:ss'
  return formatDate(new Date(), formatStr)
}
